<template>
  <div class="k4-headerContainer">
    <Header class="layout-header-bar w-100">
      <div class="main-header">
        <div class="header-left-content d-flex">
          <div class="mx-2">
            <img v-if="isMenuDrawerOpened" src="../assets/key4events_logo_text_white.svg" alt="Key4Events Logo" class="k4-key4eventsLogo"/>
            <img v-else src="../assets/key4lead_logo_image_blue_background.png" alt="K4Lead Logo" class="k4-k4leadLogo"/>
          </div>

          <div class="mx-3">
            <Icon class="burgerIco text-white p-2" :type="isMenuDrawerOpened ? 'md-arrow-back' : 'md-menu'"
                :class="rotateIcon"
                size="25" role="button" @click="onMenuIconClick()" />
          </div>
        </div>
        <div class="header-right-content">
          <div>
            <div class="header-menu">
              <Menu mode="horizontal" :active-name="activeName">
                <Submenu name="account" class="account">
                  <template slot="title">
                    <Icon type="md-person" size="30" class="k4-userIcon"/>
                  </template>

                  <div class="k4-userFullName text-center py-3 font-weight-bold">
                    {{fullName}}
                  </div>

                  <div class="m-3">
                    <div v-if="getAdminUser" name="globalAdmin" @click="goToPage('GlobalAdministration')" class="k4-goToGlobalAdministration d-flex align-items-center">
                      <div class="k4-globalAdministrationIcon d-flex justify-content-center align-items-center">
                        <Icon class="ico text-white" size="30" type="md-cog"></Icon>
                      </div>
                      <div class="px-2">Global Administration</div>
                    </div>

                    <button class="btn btn-success btn-sm w-100 px-3 my-3" name="signout" @click="signOut">
                      <div class="d-flex justify-content-center align-items-center">
                        <Icon type="md-log-out" size="20"></Icon>
                        <div class="px-2">Sign Out</div>
                      </div>
                    </button>
                  </div>
                </Submenu>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </Header>

    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
  import {apiLogout, removeSession} from '../services/Authentication.service'
  import {getLoggedUser} from '../services/User.service'
  import Router from '../router';
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../main'

  export default {
    props: ['rotateIcon', 'value'],
    data() {
      return {
        spinShow: false,
        activeName: '',
        selectedEvent: null,
        eventList: [],
        fullName: localStorage.getItem('fullName'),
        admin: false,
        adminLogin: false,
        adminAuthForm: {
          Username: '',
          Password: '',
          rememberMe: false,
        },
        ruleInline: {
          Username: [
            {required: true, message: 'Please fill in the user name', trigger: 'blur'}
          ],
          Password: [
            {required: true, message: 'Please fill in the password.', trigger: 'blur'},
            {type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),

      isMenuDrawerOpened: {
        get() {
          return this.value;
        }
      }
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      onMenuIconClick(){
        this.$emit("on-menu-icon-click");
      },
      goToPage(name) {
        bus.$emit('getActiveLink', name);
      },
      signOut() {
        removeSession();
        Router.push({name: 'Authentication'});
      },
      getUserData() {
        let route = this.$router.currentRoute.name;
        if (route !== 'Login') {
          getLoggedUser(localStorage.getItem('username')).then(response => {
            this.setUserDetails(response.data);
            localStorage.setItem('fullName', response.data.firstName + ' ' + response.data.lastName);
            this.fullName = localStorage.getItem('fullName');
            if (response.data.userRoleId === 1) {
              this.admin = true;
            }
          }).catch(error => {
            this.$Message.error('Login Failed');
            this.signOut();
            console.log(error);
          });
        } else {
          Router.push({name: 'Login'});
        }
      },
    },
    mounted() {
      this.getUserData();
      this.activeName = this.$route.name
    }
  }
</script>

<style scoped>
  .k4-headerContainer {
    height: 64px;
    z-index: 1000
  }
  .k4-globalAdministrationIcon {
    background-color: var(--success);
    width: 40px !important;
    height: 40px !important;
    border-radius: 50%;
  }
  .k4-k4leadLogo {
    width: 64px; 
    height:auto;
  }
  .k4-key4eventsLogo {
    width: 10em;
  }
  .k4-userFullName {
    border-bottom: 2px solid var(--gray-light); 
    width: 400px !important;
    cursor: default;
  }
  .k4-goToGlobalAdministration {
    font-size: 1.2em;
  }
  .k4-goToGlobalAdministration:hover {
    color: var(--success);
  }
  .ivu-layout-header > div {
    padding: 0 24px;
  }

  .layout-header-bar .main-header {
    height: 64px;
    background-color: var(--primary-dark);
  }

  .header-left-content {
    float: left;
  }

  .header-right-content {
    float: right;
    font-size: 14px;
  }

  .header-right-content > div > div {
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
  }

  .current-datetime {
    margin-right: 40px;
  }

  time.clock {
    display: inline-block;
    width: 56px;
    line-height: 1;
  }

  .header-menu .ivu-menu {
    line-height: 1;
    height: initial;
  }

  .header-menu .ivu-menu:after {
    display: none;
  }

  .header-menu .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu.ivu-menu-item-active,
  .header-menu .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: none;
    color: #ffffff;
  }

  .header-menu .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu.ivu-menu-item-active,
  .header-menu .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    border-bottom: none;
    color: #000000;
  }

  .k4-userIcon {
    background-color: #fff;
    color: #006DAC;
    padding: 5px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    text-align: center;
    vertical-align: middle;
  }

  .userAvatar .ivu-avatar-large.ivu-avatar-icon {
    font-size: 32px;
  }

  .header-menu .ivu-menu-horizontal .ivu-menu-submenu {
    padding: 0 14px;
  }

  .header-menu .ivu-menu-horizontal .ivu-menu-submenu.account {
    padding-right: 0;
  }

  .burgerIco {
    border-radius: 50%;
  }
  .burgerIco:hover {
    background-color: var(--indigo);
  }
</style>




// WEBPACK FOOTER //
// src/components/Header.vue